import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useExpanded, useTable } from 'react-table';

import APIRequests from "~/services/requests/api";

// COMPONENTES DE BASEPAGE
import { BasePageMain, BasePageContainer, BasePageBox, BasePageTitleContainer, BasePageTitle, BasePageButtonsContainer, BasePageTopLineSeparator } from "~/components/BasePage";

// TABLE
import { Table, Thead, Tbody, Tr, Th, Td } from '~/components/Table';

// COMPONENTES GERAIS
import NavigationBar from "~/components/NavigationBar";
import ButtonPrimary from '~/components/ButtonsOutline/Small/Secondary';
import TableR from "~/components/TableR";

export default function PageHome() {
    const navigate = useNavigate();

    return (
        <BasePageMain>
            <NavigationBar />

            <BasePageContainer>


            </BasePageContainer>
        </BasePageMain >
    );
}
